import React, { Component } from 'react';
import { UserComponent } from '../UserComponent';
import Request from 'components/Request';
import InputSwitch from '../elements/InputSwitch';
import AutolinkedTextComponent from "../elements/AutolinkedTextComponent";

export default class InfractionSummary extends Component {

	constructor(props) {
		super(props);
		const { infraction } = props;
		this.state = {
			isUpdating: false,
			editPopupActive: false,
		};
		this.playerCanSeeToggle = this.playerCanSeeToggle.bind(this);
		this.infractionIsActiveToggle = this.infractionIsActiveToggle.bind(this);

		this.editInfractionPopupInitiate = this.editInfractionPopupInitiate.bind(this);
	}

	editInfractionPopupInitiate() {
		this.setState({
			editPopupActive: true
		});
	}

	playerCanSeeToggle() {
		const { infraction } = this.props;
		this.setState({
			isUpdating: true
		});

		const data = {
			id: infraction.id,
			set: !infraction.player_can_see
		};
		infraction.player_can_see = data.set;
		Request.apiv1('infraction/player_can_see', data)
			.then((response) => {
				infraction.update(response.infraction);
			})
			.catch((error) => {
				Request.generalJsonError(error);
			})
			.finally(() => {
				this.setState({
					isUpdating: false
				});
			});
	}

	infractionIsActiveToggle() {
		const { infraction } = this.props;
		this.setState({
			isUpdating: true
		});
		const data = {
			id: infraction.id,
			set: !infraction.active
		};
		infraction.active = data.set;
		Request.apiv1('infraction/is_active', data)
			.then((response) => {
				infraction.update(response.infraction);
			})
			.catch((error) => {
				Request.generalJsonError(error);
			})
			.finally(() => {
				this.setState({
					isUpdating: false
				});
			});
	}

	render() {
		const { infraction, isOnePlayerOnly } = this.props;
		/** ASSIGNED TO IS Always shown since an infraction may be assigned to another account... */
		return (
			<div className={`panel infraction_view ${!!infraction.active ? 'active' : ''}`}>

				<div className='panel-heading flex flex-column flex-space-between '>
					<div className='flex flex-row flex-no-wrap'>
						<div className='flex flex-column flex-grower-no-shrinker'>
							<div>
								{!!infraction.assigned_to &&
								<div className='assigned_to'>
									<span> Assigned To</span>{' '}
									<UserComponent
										showModGavel={false}
										user={infraction.assigned_to}
									/>
								</div>
								}
								{!infraction.assigned_to &&
								<span className='error'>
									Assigned to NoBody!?
								</span>
								}
							</div>
						</div>
						{myUser.isLadderMod() &&
						<div className='mod_stuff flex flex-column flex-grower-no-shrinker'>
							<div>
								{infraction.assigned_by && myUser.isLadderMod() &&
								<div className='assigned_by'>
									<span>Assigned By</span>{' '}
									<UserComponent
										showModGavel={false}
										user={infraction.assigned_by}
									/>
								</div>
								}
							</div>

						</div>
						}
					</div>
					<div className='reason'>
						<span className='emphasized_time'>{infraction.type_name}</span>
						{myUser.isLadderMod() &&
						<a
							className='edit_infraction_link'
							href={infraction.editUrl()}>
							<i className='fa fa-pencil' />
						</a>
						}
					</div>
				</div>

				<div className='panel-body'>

					{infraction.bug_id &&
					<a href={infraction.getReportUrl()}>
						<span>
							{!!infraction.report.reporter &&
							<React.Fragment>
								<UserComponent
									user={infraction.report.reporter}
								/>{' '}
								reported{' '}
								<UserComponent
									user={infraction.report.reported}
								/>
								{' '}
							</React.Fragment>
							}
						</span>
						{!!infraction.chat &&
						<span>In {!!infraction.chat && infraction.chat.name ? infraction.chat.name : ''} Chat</span>
						}
					</a>
					}
					{!!infraction.match &&
					<div>
						<a href={infraction.match.getUrl()}>{infraction.match.ladder.name} Match {infraction.match.getTypeName()}</a>
					</div>
					}
					<div className='messages'>
						<div className='infraction_message'>
							{!!infraction.referred_player &&
							<div>
								Associated With{' '}
								<UserComponent
									user={infraction.referred_player}
								/>
							</div>
							}
							<span className='infraction_message message'>
								<AutolinkedTextComponent
									text={infraction.message ? infraction.message : ''}
								/>
							</span>
						</div>
						{myUser.isLadderMod() && infraction.public_message !== null &&
						<div className='infraction_public_message'>
							<div>
								Public Part <span className='cross-bone' title='Recent Toxic Match Behavior'>☣</span>
							</div>
							<span className='infraction_message message'><span
								className='public_message'>{infraction.public_message}</span></span>
						</div>
						}
					</div>
				</div>
				<div className='panel-footer'>
					<div className='date_holder'>
						<span className='date' title={infraction.created_at.format('LLL')}>
							{infraction.created_at.format('LLL')}
						</span>
					</div>
					{myUser.isLadderMod() &&
					<React.Fragment>
						<div className='infraction_update_items'>
							<form className='infraction_visibility'>
								<InputSwitch
									onChange={this.playerCanSeeToggle}
									name='set'
									value='1'
									checked={!!infraction.player_can_see}
									content='Player Visible'

								/>
							</form>
							<form className='infraction_active '>
								<InputSwitch
									onChange={this.infractionIsActiveToggle}
									name='set'
									value='1'
									checked={!!infraction.active}
									content='Is Active'
								/>
							</form>
						</div>
					</React.Fragment>
					}

				</div>
			</div>
		);
	}
}